angular.module('currencyFormat', ['currencyFormat.iso']).filter('currencyFormat', [
  '$rootScope', '$filter', '$sce', 'currencyFormatService', function($rootScope, $filter, $sce, currencyFormatService) {

    function fixNumber(numberValue, toFixed) {
      return parseFloat(
          parseFloat((numberValue || 0).toString()).toFixed(toFixed || 9)
      );
    }

    /**
     * Transforms an amount into the right format and currency according to a passed currency code (3 chars).
     *
     * @param float amount
     * @param string currencyCode e.g. EUR, USD
     * @param number fractionSize User specified fraction size that overwrites default value
     * @return string
     */
    return function(value, currency, decimalsPoint) {
      var fixValue = fixNumber(value, decimalsPoint || 9);

      if (!currency) {
        return currencyFormatService.format(fixValue, {precision: decimalsPoint || 2, thousand: '', decimal: '.'});
      }
      var findCurrency = currencyFormatService.findCurrency(currency);

      if (value === null) {
        if (findCurrency) {
          return findCurrency.symbol;
        }
        return currency;
      }
      if (!value && value !== 0) {
        return '';
      }

      if (decimalsPoint === null) {
        var matchResult = fixValue.toString().match(/\.(\d+)/);
        if(matchResult && matchResult[1]) {
          decimalsPoint = matchResult[1].length;
        }

      }
      // if (value === null && !!currency) {
      //   if (findCurrency) {
      //     return findCurrency.symbol;
      //   }
      //   return currency;
      // }
      // if (!value && value !== 0) {
      //   return '';
      // }
      if (findCurrency) {
        return currencyFormatService.format(fixValue, {code: currency, precision: decimalsPoint || findCurrency.precision});
      } else {
        return currencyFormatService.format(fixValue, {precision: decimalsPoint || 9, thousand: ''}) + (currency ? (' ' + currency) : '');
        // return `${currencyFormatService.format(fixValue, {precision: decimalsPoint || 2, thousand: ''})}` +
        //     (currency ? ` ${currency}` : '');
      }
    };
  }]);
